const preventDefault = (event: Event): void => event.preventDefault();

export default preventDefault;
